import { Component, type ErrorInfo, type ReactNode } from 'react'
import i18n from '@/shared/i18n'

type Props = { children: ReactNode; fallback?: ReactNode }
type State = { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // TODO: заменить на отправку в систему мониторинга, когда она появится
    console.error('[boundary]', error, info.componentStack)
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children
    return this.props.fallback ?? <p role="alert">{i18n.t('errors.boundary')}</p>
  }
}
